export const COVERSHEET_REQUIRES_PDF_TOOLTIP =
  "Add at least one PDF attachment to generate a coversheet";

export const getAttachmentFilename = (attachment) => {
  if (!attachment) return "";
  if (typeof attachment === "string") return attachment;
  return attachment.filename || attachment.name || "";
};

export const isPdfAttachment = (attachment) => {
  if (!attachment) return false;

  if (attachment instanceof File) {
    return (
      attachment.type === "application/pdf" ||
      getAttachmentFilename(attachment).toLowerCase().endsWith(".pdf")
    );
  }

  const filename = getAttachmentFilename(attachment);
  const contentType =
    attachment.content_type || attachment.contentType || attachment.type;

  return (
    contentType === "application/pdf" ||
    filename.toLowerCase().endsWith(".pdf")
  );
};

export const hasPdfAttachments = (attachments) => {
  if (!Array.isArray(attachments) || attachments.length === 0) return false;
  return attachments.some(isPdfAttachment);
};
